module.exports = __webpack_public_path__ + "static/media/1 20 trygt.c7894adf.mp3";